<template>
  <ul class="navbar-nav navbar-right">
    <li class="dropdown navbar-user">
      <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
        <img src="/beta/static/img/admin/avatars/default-user-64.png" class="img-avatar" alt="admin">
        <span class="d-none d-md-inline">Admin</span> <b class="caret"></b>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a href="javascript:;" class="dropdown-item">Setting</a>
        <div class="dropdown-divider"></div>
        <a href="/beta/admin/logout" class="dropdown-item">Log Out</a>
      </div>
    </li>
  </ul>
</template>
<script>
import Vuex from 'vuex'
export default {
  name: 'header-dropdown',
  methods: {
    ...Vuex.mapActions(['logout'])
  }
}
</script>
<style>
.img-avatar {
  background: #E4E5E6;
}
.header .navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top: 1px solid #f2f3f4;
  box-shadow: 0 13px 25px -2px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.header .dropdown-menu {
  padding: 10px;
  min-width: 100px;
}

.dropdown-item,
.dropdown-menu > li > a {
  display: block;
  padding: 5px 15px;
  clear: both;
  font-weight: 400; 
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.header-nav .nav > li > a {
  color: #212121;
  line-height: 56px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.header .dropdown-menu {
  padding: 10px;
  min-width: 100px;
}

.dropdown-item,
.dropdown-menu > li > a {
  display: block;
  padding: 5px 15px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}
.dropdown-divider,
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.open > .dropdown-menu {
  display: inline-table;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/Header/HeaderDropdown.vue